import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField, ThemeProvider, createTheme } from "@mui/material";
import React from "react";
//import { Finish } from "../../model/finish.model";
import { FinishesService } from "../../service/finishes.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import { Brand } from "../../model/brand.model";

function FinishesDetails(this: any) {
  const params = useParams();

  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = useState(1);
  const [finishDesc, setfinishDesc] = useState("");
  const [finishCode, setfinishCode] = React.useState("");
  const finishesService = new FinishesService();

  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);
  const location = useLocation();
  const [selectedBrandId, setSelectedBrandId] = useState("select");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);


  let parameters = {}
  let iscalled = false;
  useEffect(() => {

    if (!iscalled) {
      iscalled = true


      if (location != null && location.state != null && location.state.finishDetails != null) {

        console.log("+++++++++++++++")
        console.log("^*^*^*^*^*^*^*^*finishDetails ", location.state.finishDetails.colorDesc + "," +
          location.state.finishDetails.colorCode + "," + location.state.finishDetails.status)


        setAvailableBrands(location.state.brandsData)
        setSelectedBrandId(location.state.selectedBrand)

        setfinishDesc(location.state.finishDetails.colorDesc)
        setfinishCode(((location.state.finishDetails.colorCode).split("/").pop()))
        setStatus(location.state.finishDetails.status)
        setIsEdit(false)

      } else if (location != null && location.state != null && location.state.brandsData != null) {

        setAvailableBrands(location.state.brandsData)
        setSelectedBrandId(location.state.selectedBrand)

      }
    }
  }, []);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };


  const [submitClick, setsubmitClick] = React.useState(false);
  const createNewFinish = () => {

    if (finishDesc == "" || finishCode == null) {
      setsubmitClick(true)
      return
    }
    // ColorDesc and colorCode to be ussed as API is set on these variables... RC
    const data = {
      "colorDesc": finishDesc,
      "status": status,
      "brandId": selectedBrandId,
      "colorCode": finishCode
    };
    finishesService.createFinish(data).then((res: any) => {
      /*  toast.success('Finish created successfully', {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate('../finishes');
      }).catch((err: any) => {
        console.log('err ', err);
        setErrMsg('Something went wrong while creating the product');
      });*/
      if (res.status == '100') {

        toast.success("Updated Successfully !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../finishes');
        }, 2100);

      } else {
        toast.error("No Data Available!!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigate('../finishes');
        }, 2100);
      }
    })
  };

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });

  return (

    <div className="App">
      <div className="card m-8">

        <div className="card-body ">

          <div className="row pt-4">


            <div className="col-4 form-group  text-left">
              <ThemeProvider theme={CustomFontTheme}>
                <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}
                  disabled={!isedit}
                  onChange={(e: any) => {
                    setSelectedBrandId(e.target.value);
                  }}>
                  <MenuItem style={{ fontSize: "small" }} disabled value="select" key="select">Select</MenuItem>
                  {availableBrands.map((_el: any) => <MenuItem style={{ fontSize: "small" }} key={_el.brandId} value={_el.brandId}>{_el.brandName}</MenuItem>)}
                </TextField>
              </ThemeProvider>
            </div>

            <div className='col-md-4 text-left'>


              <div className="form-group ">
                <TextField size="small" label="Finish Code" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  type="text" className="form-control" name='finishCode' value={finishCode}
                  error={submitClick && (finishCode == "" || finishCode == null)}
                  //  helperText={ (submitClick &&   (finishName == "" || finishName == null)) ? 'required*' : ""}

                    disabled={!isedit}
                  onChange={(e: any) => {
                    setfinishCode(e.target.value)
                  }}
                />
              </div>


            </div>

            <div className="col-md-4 text-left">
              <div className="form-group  font_size_13px">

                <TextField size="small" label="Finish Description" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 35 } }}
                  type="text" className="form-control" name='prodDispName' value={finishDesc}
                  error={submitClick && (finishDesc == "" || finishDesc == null)}
                  //  helperText={ (submitClick &&   (finishName == "" || finishName == null)) ? 'required*' : ""}

                  //  disabled={!isedit}
                  onChange={(e: any) => {
                    setfinishDesc(e.target.value)
                  }}
                />
              </div>
            </div>





            <div className="col-md-4 text-left">
              <div className="form-group"  >
                <label className="form-group mr-3 pt-2" > Status</label>
                <FormControl><RadioGroup row name='status' value={status}
                  onChange={(e) => { setStatus(Number(e.target.value)) }} >
                  <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
                </FormControl>
              </div>
            </div>

          </div>
        </div>
        <div className="card-footer col-12 text-center">
          <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewFinish()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
            Submit
          </Button>
          <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../finishes')} variant="text" startIcon={<ClearOutlinedIcon />}>
            Cancel
          </Button>
        </div>
      </div>
      <ToastContainer />

    </div>
  );
}

export default FinishesDetails;
